import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
	constructor(m) {
		super(m);
	}

	init() {
		const item = this.el; // elemento raíz del módulo (contendrá .searchbox)
		
		const cats = item.querySelector('.js-cats');

		const checkboxes = Array.prototype.slice.call(item.querySelectorAll('input[name="cat[]"]'));

		const settings = { persist: false };
		let ts = null; // TomSelect instance

		function isDesktop() {
			// Ajusta breakpoint si es necesario
			return window.matchMedia('(min-width: 1024px)').matches;
		}

		function enableDesktopMode(){
			// Desktop: disable select (mcats[]) so only checkboxes (cat[]) submit
			if (cats){
				try{ cats.disabled = true; }catch(e){}
				// destroy TomSelect if exists
				if (ts && typeof ts.destroy === 'function'){
					try{ ts.destroy(); }catch(e){}
					ts = null;
				}
			}
			// enable checkboxes
			checkboxes.forEach(function(cb){ cb.disabled = false; });
		}

		function enableMobileMode(){
			// Mobile: enable select (mcats[]) and disable checkboxes
			if (cats){
				try{ cats.disabled = false; }catch(e){}
				// initialize TomSelect if not present
				if (!ts){
					try{ ts = new TomSelect(cats, settings); }catch(e){ console.warn('TomSelect init failed', e); }
				}
			}
			// disable checkboxes so they don't submit alongside select
			checkboxes.forEach(function(cb){ cb.disabled = true; });
		}

		// debounce helper
		function debounce(fn, wait){
			let t = null;
			return function(){
				clearTimeout(t);
				const args = arguments;
				t = setTimeout(function(){ fn.apply(null, args); }, wait);
			};
		}

		function applyMode(){
			if (isDesktop()) enableDesktopMode(); else enableMobileMode();
		}

		// initial
		applyMode();
		// respond to resize
		window.addEventListener('resize', debounce(applyMode, 150));
	}
}

